import { DynamoDBClient } from '@aws-sdk/client-dynamodb';
import { DynamoDBDocumentClient, GetCommand, PutCommand } from '@aws-sdk/lib-dynamodb';

export interface AdminSettings {
  usdToGbp: number;
  usdToEur: number;
  /** Generated pipeline fixed cost (Bedrock description + image prompt + Nova Canvas). */
  articleFixedCostCents: number;
  /** Imported pipeline fixed cost (cleanup + CEFR + summarise + description + image). */
  importFixedCostCents: number;
  basePerWordMicrocents: number;
  audioPerWordMicrocents: number;
  translationFixedCostCents: number;
  welcomeCreditCents: number;
  minDepositCents: number;
  maxDepositCents: number;
  maxImportWords: number;
  minArticleWords: number;
  maxArticleWords: number;
  maxChunkWords: number;
  updatedAt: string;
}

export const ADMIN_SETTINGS_DEFAULTS: AdminSettings = {
  usdToGbp: 0.79,
  usdToEur: 0.92,
  articleFixedCostCents: 11,
  importFixedCostCents: 14,
  basePerWordMicrocents: 345,
  audioPerWordMicrocents: 80,
  translationFixedCostCents: 2,
  welcomeCreditCents: 100,
  minDepositCents: 200,
  maxDepositCents: 100_000,
  maxImportWords: 5_000,
  minArticleWords: 100,
  maxArticleWords: 2_000,
  maxChunkWords: 80,
  updatedAt: '',
};

const PK = 'admin#settings';
const SK = 'admin#settings';

export class AdminSettingsEntity {
  private docClient: DynamoDBDocumentClient;
  private tableName: string;

  constructor(tableName: string, dynamoClient?: DynamoDBClient) {
    const client = dynamoClient || new DynamoDBClient({});
    this.docClient = DynamoDBDocumentClient.from(client);
    this.tableName = tableName;
  }

  async getSettings(): Promise<AdminSettings> {
    const result = await this.docClient.send(new GetCommand({
      TableName: this.tableName,
      Key: { pk: PK, sk: SK },
    }));

    if (!result.Item) {
      return { ...ADMIN_SETTINGS_DEFAULTS };
    }

    const { pk, sk, ...fields } = result.Item;
    return { ...ADMIN_SETTINGS_DEFAULTS, ...fields };
  }

  async saveSettings(settings: Omit<AdminSettings, 'updatedAt'>): Promise<AdminSettings> {
    const saved: AdminSettings = {
      ...settings,
      updatedAt: new Date().toISOString(),
    };

    await this.docClient.send(new PutCommand({
      TableName: this.tableName,
      Item: { pk: PK, sk: SK, ...saved },
    }));

    return saved;
  }
}
